export const DEFAULT_CANVAS_FONT_FAMILY = "normal";
export const DEFAULT_CANVAS_FONT_STYLE = "normal";
export const DEFAULT_CANVAS_FONT_WEIGHT = 400;
export const ITALIC_FONT_STYLE = "italic";

// Same family set the note editor's Quill toolbar registers.
export const CANVAS_FONT_FAMILIES = Object.freeze([
  { id: "normal", label: "Normal", stack: "Montserrat, sans-serif" },
  { id: "sans-serif", label: "Sans Serif", stack: "Arial, Helvetica, sans-serif" },
  { id: "serif", label: "Serif", stack: "Georgia, 'Times New Roman', serif" },
  { id: "monospace", label: "Monospace", stack: "'Courier New', Courier, monospace" },
  { id: "palisade", label: "Palisade", stack: "'Palisade', cursive" },
]);

export const CANVAS_FONT_WEIGHTS = Object.freeze([
  { label: "Regular", value: 400 },
  { label: "Semi-bold", value: 600 },
  { label: "Bold", value: 700 },
]);

const FONT_STACKS_BY_ID = new Map(
  CANVAS_FONT_FAMILIES.map((family) => [family.id, family.stack])
);

/**
 * @param {string} fontFamilyId - persisted family id (Quill-compatible)
 * @returns {string} CSS font stack for canvas and editor rendering
 */
export const getCanvasFontStack = (fontFamilyId) =>
  FONT_STACKS_BY_ID.get(fontFamilyId) ??
  FONT_STACKS_BY_ID.get(DEFAULT_CANVAS_FONT_FAMILY);
